// src/services/notification.service.js
import api from './api';

const notificationService = {
  getNotifications: async (page = 1, limit = 20, unreadOnly = false) => {
    const params = { page, limit };
    if (unreadOnly) params.unreadOnly = true;
    const res = await api.get('/notifications', { params });
    return res.data;
  },

  getUnreadCount: async () => {
    const res = await api.get('/notifications/unread-count');
    return res.data;
  },

  markRead: async (id) => {
    const res = await api.post(`/notifications/${id}/read`);
    return res.data;
  },

  markAllRead: async () => {
    const res = await api.post('/notifications/read-all');
    return res.data;
  },

  deleteNotification: async (id) => {
    const res = await api.delete(`/notifications/${id}`);
    return res.data;
  },

  getUpcomingBirthdays: async (companyId = null) => {
    const params = {};
    if (companyId) params.companyId = companyId;
    const res = await api.get('/notifications/birthdays/upcoming', { params });
    return res.data;
  },

  checkMyBirthday: async () => {
    const res = await api.get('/notifications/birthdays/me');
    return res.data;
  },
};

export default notificationService;